import validationRules from '@/utils/validationRules';

export default {
  install(Vue) {
    Vue.prototype.$rules = validationRules;
  }
};
